import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Header from './components/Header';
import PostList from './components/PostList';
import PostDetail from './components/PostDetail';

const App: React.FC = () => {
  return (
    <Router>
      <div>
        <Header />
        <Container>
          <Routes>
            <Route path="/" element={<PostList />} />
            <Route path="/post/:id" element={<PostDetail />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
};

export default App;
